/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

(function(appSpace, $, undefined){
var autoplay = true;

/**
 * Represents a Mobile App Step
 * @constructor
 * @param {oject} jQuery object that holds the steps
 */
appSpace.ATDMobileAppStep = function(stepEl) {
    var _this = this;

    _this.activeStep = 0; // index of active step
    _this.steps = []; // array to hold steps
    
    _this.initSteps(stepEl);
};

/**
 * Initializes steps
 * 
 * @param {oject} jQuery object that holds the stepEl
 */
appSpace.ATDMobileAppStep.prototype.initSteps = function(stepEl) {
    var _this = this;

    _this.stepEl = stepEl;

    // populate steps array
    _this.stepEl.find('.current-step').each(function() {
    var step = {},
        img = new Image();
    step.el = $(this);

    img.src = '/wp-content/themes/b2b.autotrader/dist/img/connections_app/' + step.el.data('screenshot');
    $(img).appendTo('#screenshot-container');

    step.img = $(img);

    _this.steps.push(step);
    });

    _this.stepEl.find('.max-steps').html(_this.steps.length);
    _this.stepEl.find('.current-count').html(_this.activeStep + 1);

    _this.stepEl.find('.step-prev').addClass('inactive');
    if(_this.steps.length <= 1) {
    _this.stepEl.find('.step-next').addClass('inactive');
    }

    _this.steps[0].img.addClass('active');

    // click handlers for step buttons
    _this.stepEl.on('click', '.step-prev', function(e) {
    e.preventDefault();
    _this.advanceStep(true);

    if (autoplay) {
    clearInterval(autoplay);
    }
    });

    _this.stepEl.on('click', '.step-next', function(e) {
    e.preventDefault();
    _this.advanceStep(false);

    if (autoplay) {
        clearInterval(autoplay);
    }
    });

    if (_this.stepEl.data('autoplay')) {
    autoplay = setInterval(function() {
        _this.advanceStep(false);
    }, 5000);
    }

    $('[data-step-toggle="' + _this.stepEl.attr('id') + '"]').on('click', function(e) {
        e.preventDefault();

    if (autoplay) {
        clearInterval(autoplay);
    }

    $('[data-step-toggle]').removeClass('active');
    $(this).addClass('active');
        
        $('[data-mobile-app="step"], [data-step-visible]').removeClass('active');

        $('[data-step-visible="' + _this.stepEl.attr('id') + '"]').addClass('active');
        _this.stepEl.addClass('active');
        _this.activateStep(0, false);
    });
};

/**
 * Advance step
 * 
 * @param {boolean} should reverse direction
 */
appSpace.ATDMobileAppStep.prototype.advanceStep = function(reverse) {
    var _this = this,
    newIndex = _this.activeStep;

    if(reverse) {
    if(newIndex > 0) {
        newIndex--;
    }
    }
    else {
    if(newIndex < _this.steps.length - 1) {
        newIndex++;
    }
    }

    _this.activateStep(newIndex, reverse);
};

/**
 * Activate step given index
 * 
 * @param {integer} index of step to activate
 * @param {boolean} is animation reversed?
 */
appSpace.ATDMobileAppStep.prototype.activateStep = function(index, reverse) {
    var _this = this;

    if(typeof reverse === 'undefined') {
    if(index < _this.activeStep) {
        reverse = true;
    }
    }

    if(_this.steps.length > index) {
    _this.steps[index].el.addClass('active');
    
    _this.deactivateStep(reverse, index);

    _this.activeStep = index;

    _this.steps[index].img.addClass('active');
    _this.stepEl.find('.current-count').html(_this.activeStep + 1);
    }

    if(_this.activeStep < _this.steps.length - 1) {
    _this.stepEl.find('.step-next').removeClass('inactive');
    } else {
    _this.stepEl.find('.step-next').addClass('inactive');
    }

    if (_this.activeStep > 0) {
    _this.stepEl.find('.step-prev').removeClass('inactive');
    } else {
    _this.stepEl.find('.step-prev').addClass('inactive');
    }
};

/**
 * Deactivate current step
 * @param {boolean} is animation reversed?
 * @param {integer} index of new step
 */
appSpace.ATDMobileAppStep.prototype.deactivateStep = function(reverse, index) {
    var _this = this,
    i = _this.activeStep;

    if (reverse) {
    $('#screenshot-container').removeClass('forwards').addClass('backwards');
    } else {
    $('#screenshot-container').removeClass('backwards').addClass('forwards');
    }

    $('#screenshot-container img').removeClass('active');

    if(i !== index) {
    _this.steps[i].el.removeClass('active');
    }
};

$(document).ready(function() {
    $('[data-mobile-app="step"]').each(function() {
        new appSpace.ATDMobileAppStep($(this));
    });
});
}(window.atdApp = window.atdApp || {}, $));
